import React from "react";
import { Progress } from "reactstrap";
import { FormattedMessage } from "react-intl";

const StudentProgress = props => {
  if (props.doneModules > 0) {
    if (props.doneModules === props.totalModules) {
      return (
        <Progress
          color="success"
          style={{ marginTop: "-15px" }}
          value={props.progress}
          max={100}
        >
          <div>
            {props.doneModules}/{props.totalModules}{" "}
            <FormattedMessage id="Done" />
          </div>
        </Progress>
      );
    }
    return (
      <Progress
        striped
        animated
        color="info"
        style={{ marginTop: "-15px" }}
        value={props.progress}
        max={100}
      >
        <div
          className="text-truncate"
          title={
            props.doneModules + "/" + props.totalModules + " moduler klara"
          }
        >
          {props.doneModules}/{props.totalModules}{" "}
          <FormattedMessage id="Done" />
        </div>
      </Progress>
    );
  }

  return <div />;
};

export default StudentProgress;
